module.exports = __webpack_public_path__ + "img/CARDS.8c2619c8.svg";